"use client";

import Link from "next/link";

import { deriveStatus } from "@/lib/public-hearings/apply-filters";
import { relativeDeadline } from "@/lib/public-hearings/deadline";
import type { Hearing } from "@/lib/public-hearings/types";
import { useFocus } from "../focus-context";
import { CoverReportLink } from "./CoverReportLink";
import { DmapLink } from "./DmapLink";
import { formatDeadlineSub } from "./constants";

export function RowActions({
  hearing: h,
  detailUrl,
}: {
  hearing: Hearing;
  detailUrl: string;
}) {
  const { setFocus } = useFocus();
  const status = deriveStatus(h);
  const relative = relativeDeadline(h.submissionDeadlineUtc);
  const deadlineSub = formatDeadlineSub(h.submissionDeadlineUtc, relative.closed);
  const dmap = h.dmapUrls[0];

  return (
    <div className="ph-actions">
      <div className="ph-row-status" data-tone={status}>
        <span className="ph-row-status-v">
          <span className="ph-row-status-dot" aria-hidden="true" />
          {relative.label}
        </span>
        <span className="ph-row-status-sub">{deadlineSub}</span>
      </div>
      <div className="ph-actionlinks">
        {h.coverReportUrl && <CoverReportLink href={h.coverReportUrl} />}
        {dmap && <DmapLink href={dmap} />}
      </div>
      <Link
        className="ph-cta"
        href={detailUrl}
        scroll={false}
        onClick={(e) => {
          e.preventDefault();
          setFocus(h);
        }}
      >
        Weigh in <span className="arr">→</span>
      </Link>
    </div>
  );
}
